export default __webpack_public_path__ + "static/media/ic-leaves.00523bfa.svg";